import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { myDesignService } from "../../../services";
import {
  Box,
  AppBar,
  Tabs,
  Tab,
  Container,
  CircularProgress,
} from "@mui/material";
import CampaignPlaylistManager from "../../../components/campaignPlaylistManager/CampaignPlaylistManager";
import CampaignUnusedContent from "../../../components/campaignPlaylistManager/CampaignUnusedContent";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={props.disablegutters ? 0 : 3}>{children}</Box>
      )}
    </div>
  );
}

const CampaignContentManager = (props) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [index, setIndex] = useState(0);
  const [playlist, setPlaylist] = useState(null);
  const [content, setContent] = useState(null);
  const [ordered, setOrdered] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    myDesignService
      .fetchCampaignPlaylist(
        props.selectedCampaign.campaignId,
        props.selectedCampaign.id,
        () =>
          enqueueSnackbar(t("toasts.fetchCampaignPlaylistError"), {
            variant: "error",
          })
      )
      .then((res) => setPlaylist(res));
    myDesignService
      .fetchCampaignContent(props.selectedCampaign.campaignId, () =>
        enqueueSnackbar(t("toasts.fetchCampaignPlaylistError"), {
          variant: "error",
        })
      )
      .then((res) => setContent(res));
  }, []);

  useEffect(() => {
    if (playlist && content && !ordered) {
      let tmpContent = [...content];
      const r = tmpContent.filter(
        (elem) => !playlist.find(({ user }) => elem.id === user.id)
      );
      setContent(r);
      setOrdered(true);
    }
  }, [playlist, content]);

  function handleChange(e, value) {
    setIndex(value);
  }

  function a11yProps(index) {
    return {
      id: `scrollable-prevent-tab-${index}`,
      "aria-controls": `scrollable-prevent-tabpanel-${index}`,
    };
  }

  if (!playlist || !content || !ordered) {
    return (
      <Container>
        <div className="loading-container">
          <CircularProgress size={50} />
        </div>
      </Container>
    );
  } else {
    return (
      <div>
        <AppBar position="static" color="default">
          <Tabs
            value={index}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab
              label={t("myDesign.campaigns.campaignPlaylist")}
              {...a11yProps(0)}
              sx={{ background: "#424242" }}
            />
            <Tab
              label={t("myDesign.campaigns.inactiveContent")}
              {...a11yProps(1)}
              sx={{ background: "#424242" }}
            />
          </Tabs>
        </AppBar>
        <TabPanel value={index} index={0} dir={theme.direction}>
          <CampaignPlaylistManager
            playlist={playlist}
            setPlaylist={setPlaylist}
            content={content}
            setContent={setContent}
            selectedCampaign={props.selectedCampaign}
          />
        </TabPanel>
        <TabPanel value={index} index={1}>
          <CampaignUnusedContent
            content={content}
            setContent={setContent}
            selectedCampaign={props.selectedCampaign}
            playlist={playlist}
            setPlaylist={setPlaylist}
          />
        </TabPanel>
      </div>
    );
  }
};

export default CampaignContentManager;
